import React from "react";
import { Provider } from "react-redux";

import { Routes } from "./routes";
import { I18nProvider } from "./Lang/i18n";
import { MaterialThemeProvider } from "./Layout/metronicLayout";

function App({ store }) {
  return (
    <Provider store={store}>
      <MaterialThemeProvider>
        <I18nProvider>
          <Routes />
        </I18nProvider>
      </MaterialThemeProvider>
    </Provider>
  );
}

export default App;
